import {Pipe, PipeTransform} from '@angular/core';
import { Currency } from "../../shared-gen/Model/Utils/Currency";
import {formatCurrency, registerLocaleData} from '@angular/common';
import localeDa from '@angular/common/locales/da';
import localeDe from '@angular/common/locales/de';
import localeDeCH from '@angular/common/locales/de-CH';
import localeEnAU from '@angular/common/locales/en-AU';
import localeEnGB from '@angular/common/locales/en-GB';

/**
 * Formats amounts of money given an iovent-registered currency to a string
 * in default format for that currency/locale.
 *
 * Don't forget to register the required locals in the app module, by calling
 * registerLocales() from this class.
 */
@Pipe({
    name: 'iocurrency', // "io-" because Angular also has a "currency" pipe
    pure: true
})
export class CurrencyPipe implements PipeTransform {

    transform(value: number, currency: Currency): any {
        return formatIoCurrency(value, currency);
    }

}

export function formatIoCurrency(value: number, currency: Currency) {
    switch (currency) {
        case Currency.AUD: return formatCurrency(value, 'en-AU', '$', 'AUD', '1.2-2');
        case Currency.CHF: return formatCurrency(value, 'de-CH', 'Fr.', 'CHF', '1.2-2');
        case Currency.DKK: return formatCurrency(value, 'da', 'kr.', 'DKK', '1.2-2');
        case Currency.EUR: return formatCurrency(value, 'de', '€', 'EUR', '1.2-2');
        case Currency.GBP: return formatCurrency(value, 'en-GB', '£', 'GBP', '1.2-2');
        case Currency.USD: return formatCurrency(value, 'en-US', '$', 'USD', '1.2-2');
        default: return formatCurrency(value, 'de', '€', 'EUR', '1.2-2');
    }
}

export function registerLocales() {
    // Available locales: See https://github.com/angular/angular/tree/master/packages/common/locales
    registerLocaleData(localeDa, 'da');
    registerLocaleData(localeDe, 'de');
    registerLocaleData(localeDeCH, 'de-CH');
    registerLocaleData(localeEnAU, 'en-AU');
    registerLocaleData(localeEnGB, 'en-GB');
}
